import AppIcon from '../../../components/AppIcon';

const TemplatePreview = ({ template, onClose }) => {
  const sampleData = {
    '{{customer_name}}': 'أحمد محمد العتيبي',
    '{{photographer_name}}': 'سارة عبدالله النمر',
    '{{service_type}}': 'تصوير حفل زفاف',
    '{{booking_date}}': '2026-02-20',
    '{{booking_time}}': '19:00',
    '{{booking_id}}': 'BK-2026-001',
    '{{location}}': 'فندق الفيصلية، الرياض',
    '{{price}}': '8,500',
    '{{amount}}': '8,500',
    '{{transaction_id}}': 'TXN-2026-12345',
    '{{payment_date}}': '2026-01-11',
    '{{due_date}}': '2026-02-15',
    '{{new_status}}': 'مؤكد'
  };

  const replaceVariables = (text) => {
    let result = text;
    Object?.entries(sampleData)?.forEach(([key, value]) => {
      result = result?.replace(new RegExp(key, 'g'), value);
    });
    return result;
  };

  const previewSubject = replaceVariables(template?.subject);
  const previewBody = replaceVariables(template?.body);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" dir="rtl">
      <div className="bg-card rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">معاينة القالب</h2>
            <p className="text-sm text-muted-foreground mt-1">{template?.name}</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full hover:bg-muted flex items-center justify-center transition-colors"
          >
            <AppIcon name="X" size={20} />
          </button>
        </div>

        {/* Email Preview */}
        <div className="p-6">
          {/* Info Banner */}
          <div className="mb-6 p-4 bg-primary/10 border border-primary/20 rounded-lg flex items-start gap-3">
            <AppIcon name="Info" size={20} className="text-primary mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">معاينة بالبيانات التجريبية</p>
              <p className="text-xs text-muted-foreground">
                هذه معاينة للقالب مع بيانات تجريبية. سيتم استبدال المتغيرات بالبيانات الفعلية عند الإرسال.
              </p>
            </div>
          </div>

          {/* Email Container */}
          <div className="border border-border rounded-lg overflow-hidden">
            {/* Email Header */}
            <div className="bg-primary text-primary-foreground p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <AppIcon name="Camera" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-lg">مشهد</h3>
                  <p className="text-sm opacity-90">منصة حجز المصورين</p>
                </div>
              </div>
            </div>

            {/* Email Subject */}
            <div className="bg-muted/30 px-6 py-4 border-b border-border">
              <p className="text-xs text-muted-foreground mb-1">الموضوع:</p>
              <p className="text-lg font-semibold text-foreground">{previewSubject}</p>
            </div>

            {/* Email Body */}
            <div className="p-6 bg-white">
              <div className="prose prose-sm max-w-none">
                <div className="whitespace-pre-line text-foreground leading-relaxed">
                  {previewBody}
                </div>
              </div>
            </div>

            {/* Email Footer */}
            <div className="bg-muted/30 px-6 py-4 border-t border-border">
              <p className="text-xs text-muted-foreground text-center">
                هذا إيميل تلقائي من منصة مشهد
              </p>
              <p className="text-xs text-muted-foreground text-center mt-1">
                © 2026 مشهد. جميع الحقوق محفوظة.
              </p>
            </div>
          </div>

          {/* Variables Used */}
          <div className="mt-6 p-4 bg-muted/30 rounded-lg">
            <p className="text-sm font-medium text-foreground mb-3">المتغيرات المستخدمة في هذا القالب:</p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {Object?.entries(sampleData)
                ?.filter(([key]) => template?.subject?.includes(key) || template?.body?.includes(key))
                ?.map(([key, value]) => (
                  <div key={key} className="flex items-center gap-2 text-xs">
                    <AppIcon name="Check" size={14} className="text-success" />
                    <span className="text-muted-foreground">{key}</span>
                  </div>
                ))}
            </div>
          </div>

          {/* Close Button */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              إغلاق
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;